import * as React from 'react';
import Typography from '@mui/material/Typography';

export const AppName = ({raw = false, variant = 'h3'}) => {
  let appName = 'MeteoEffects';
  const env = process.env.REACT_APP_ENV || '';
  if (raw) return <React.Fragment>{appName}</React.Fragment>;

  return (
    <Typography
      variant={variant}
      sx={theme => ({
        '& > b, & > strong': {
          color: theme.palette.error.main
        }
      })}>
      {appName}
      {env && env !== 'production' && (
        <>
          {' '}
          - <b>{env.toUpperCase()}</b>
        </>
      )}
    </Typography>
  );
};

export default AppName;
